.overlay {
  background-color: var(--overlay);
  position: fixed;
  overflow: hidden auto;
  outline: 0;
  inset: 0;
  z-index: 10;
}

.dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 1px solid var(--menu-border);
  box-shadow: 0 0 30px 0 var(--shadow);
}
